import { render, staticRenderFns } from "./SuccessSubmitForm6.vue?vue&type=template&id=1fb5561c&scoped=true"
import script from "./SuccessSubmitForm6.vue?vue&type=script&lang=ts"
export * from "./SuccessSubmitForm6.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb5561c",
  null
  
)

export default component.exports